
function NavBar (){
    return (
        <div >
            <nav className="bg-purple-500 p-4 text-center">
                <h1 className="text-center text-3xl font-bold text-white">Top Courses</h1>
            </nav>
        </div>
    );
}

export default NavBar;